import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Shop from './pages/Shop';
import Blog from './pages/Blog';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import MyAccount from './pages/MyAccount';
import Wishlist from './pages/Wishlist';
import Cart from './pages/Cart';
import ShopDetails from './pages/ShopDetails';
import BlogDetails from './pages/BlogDetails';
import ShopSidebar from './pages/ShopSidebar';
import ReturnPolicy from './pages/ReturnPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { AdminRoot } from './admin/AdminRoot';
import { LoginPage } from './admin/pages/LoginPage';
import Checkout from './pages/checkout';
import Login from './pages/Login';
import ForgotPassword from './pages/Forgotpassword';
import Signup from './pages/Signup';
import Myorders from './pages/Myorders';
import Cancelorder from './pages/Cancelorder';
import TrackOrder from './pages/TrackOrder';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* User-facing routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop-sidebar" element={<ShopSidebar />} />
        <Route path="/shop-details/:slug" element={<ShopDetails />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/Cancelorder" element={<Cancelorder />} />
        <Route path="/track-order" element={<TrackOrder />} />
        {/* <Route path="/blog-details" element={<BlogDetails />} /> */}
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/return-refund-policy" element={<ReturnPolicy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/checkout" element={<Checkout/>} />
         {/* <Route path="/BlogDetails" element={<BlogDetails/>} /> */}
         <Route path="/BlogDetails/:slug" element={<BlogDetails/>} />

          <Route path="/blog/:slug" element={<BlogDetails/>} />
        <Route path="/ForgotPassword" element={<ForgotPassword/>} />
         <Route path="/my-orders" element={<Myorders />} />
        <Route path="/signup" element={<Signup/>} />
         <Route path="/Login" element={<Login/>} />
      {/* <Route path="/admin/login" element={<LoginPage />} /> */}
      <Route path="/admin/*" element={<AdminRoot />} />
        {/* Admin panel - all /admin/* routes */}
        <Route path="/admin/*" element={<AdminRoot />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
